module.exports = __webpack_public_path__ + "92dbc4b2ed4fe2c43a23d21887448642.png";